module.exports = __webpack_public_path__ + "img/rosa.35c1628d.png";